import React, { Component } from 'react';
import { connect } from 'react-redux';
import Messages from './messages';
import ChatInput from './chatinput';
import Header from './header';
import { markAllEventsAsRead, showOptions, setInputMask } from '../actions';
import { APIMode } from '../../../../api/types';
import { emojifyText } from '../../../../common/emojify';
import EmojiPicker from './emojipicker';
import { CHAT } from '../types';
import './style.scss';
import { isTextBoxVisible } from './visibility';

class ChatApp extends Component {
    constructor(props) {
        super(props);

        this.API = props.API;
        this.messageCount = 0;

        this.sendHandler = this.sendHandler.bind(this);
        this.scrollBottom = this.scrollBottom.bind(this);
        this.emojiPick = this.emojiPick.bind(this);
    }

    componentDidMount() {
        const param = {
            ...this.props.userdata,
            ...this.props.chat.registration
        };

        if (!param.category) {
            param.category = 'default';
        }
        if (!param.categoryType) {
            param.categoryType = 'chat';
        }

        this.API.start(param); // will do nothing if chat already started

        const { dispatch } = this.props;
        dispatch(markAllEventsAsRead());

        this.scrollBottom();
        this.messageCount = this.props.messageCount;
    }

    componentDidUpdate() {
        const lastCount = this.props.messageCount;
        if (this.messageCount != lastCount) {
            this.messageCount = lastCount;
            this.scrollBottom();
        }

        if (!this.props.chat.sessionActive && this.props.chat.options === 'emoji') {
            const { dispatch } = this.props;
            dispatch(showOptions(null));
        }
    }

    preventScrollHandler(e) {
        const div = e.currentTarget;
        if (div.clientHeight + div.scrollTop + e.deltaY >= div.scrollHeight) {
            // e.preventDefault();
            div.scrollTop = div.scrollHeight;
        } else if (div.scrollTop + e.deltaY <= 0) {
            // e.preventDefault();
            div.scrollTop = 0;
        }
    }

    sendHandler(message) {
        if (typeof message == 'string') {
            message = emojifyText(message);
        }
        this.API.sendMessage(message);
        this.props.chat.inputMask ? setInputMask('') : null;
    }

    scrollBottom() {
        let contentElement = document.getElementsByClassName('opl-widget-chat--content');
        if (contentElement.length > 0) {
            contentElement = contentElement[0];
            contentElement.scrollTop = contentElement.scrollHeight;
        } else {
            setTimeout(this.scrollBottom, 10);
        }
    }

    emojiPick(code) {
        if (this.props.chat.sessionActive) {
            this.appendText(code);
        }

        const { dispatch } = this.props;
        dispatch(showOptions(null));
    }

    render() {
        setTimeout(this.scrollBottom, 10);
        const disabled = !this.props.chat.sessionActive || this.props.chat.mode !== APIMode.CHAT;
        const showEndSession =
            !this.props.chat.sessionActive &&
            this.props.chat.state === 'finished' &&
            this.props.theme.includes('mojorange2');
        return (
            <div className="opl-widget-chat--container">
                {this.props.chat.agent.available &&
                    this.props.chat.agent.name !== CHAT.WIRTUALNY_KONSULTANT && (
                        <Header username={this.props.chat.agent.name} />
                    )}
                <div
                    className="opl-widget-chat--content scroll"
                    onWheel={this.preventScrollHandler}
                >
                    <Messages onSend={this.sendHandler} API={this.props.API} disabled={disabled} />
                </div>
                {this.props.chat.options && (
                    <div className="opl-widget-chat--dialog scroll">
                        {this.props.chat.options === 'emoji' && (
                            <EmojiPicker onEmojiPick={this.emojiPick} />
                        )}
                    </div>
                )}
                {this.props.chat.mode === APIMode.CHAT &&
                    (!disabled || showEndSession) &&
                    isTextBoxVisible(this.props.chat) && (
                        <div className="opl-widget-chat--footer">
                            {!disabled && (
                                <ChatInput
                                    callbacks={(callbacks) =>
                                        (this.appendText = callbacks.appendText)
                                    }
                                    onSend={this.sendHandler}
                                    disabled={disabled}
                                    API={this.props.API}
                                />
                            )}
                        </div>
                    )}
                {showEndSession && (
                    <div className="opl-widget-chat--footer-menu">
                        <button onClick={this.props.closeAction}>Zakończ rozmowę</button>
                    </div>
                )}
            </div>
        );
    }
}

ChatApp.defaultProps = {
    messageCount: 0
};

const getMessagesCount = (messages) => {
    return messages.length;
};

const mapStateToProps = (state) => {
    return {
        chat: state.chat,
        config: state.config.widget.chatOptions,
        userdata: state.config.widget.chatUserData,
        messageCount: getMessagesCount(state.chat.messages),
        theme:
            state.settings.widget && state.settings.widget.theme
                ? state.settings.widget.theme.split(' ')
                : ['default']
    };
};

export default connect(mapStateToProps)(ChatApp);
